import type { MemberDatasetField, ProvidersKey } from '@/lib/member-views/memberDataset.types';

/** A column only the report has, labelled with its report header. */
export function reportOnly<TRow>(
  id: string,
  order: number,
  label: ProvidersKey,
  value: MemberDatasetField<TRow>['value'],
  fieldFormat?: MemberDatasetField<TRow>['format'],
): MemberDatasetField<TRow> {
  return { id, label, value, format: fieldFormat, csv: { order, label } };
}
